<template>
  <div class="All">
    <div class="Header" v-if="userId && infoLists.length > 0">
      <div class="SearchBox">
        <i class="iconfont icon-search SearchIcon"></i>
        <input type="text" v-model="searchQuery" class="SearchInput" placeholder="搜索记录..."/>
      </div>
    </div>

    <van-skeleton title :row="3" v-if="isLoading" class="SkeletonBox"/>

    <div class="RecordList" v-if="userId && filteredLists.length > 0 && !isLoading">
      <van-swipe-cell
          v-for="(item, index) in filteredLists"
          :key="index"
          class="SwipeCell"
      >
        <div class="RecordCard" @click="handleClick(item)">
          <div class="RecordHeader">
            <div class="RecordTitle">
              {{ item.title || `随记-${formatDate(item.updated_at)}` }}
            </div>
            <div class="RecordAction">
              <span>查看</span>
              <i class="iconfont icon-xiangyoujiantou"></i>
            </div>
          </div>

          <div class="RecordContent">
            {{ getLatestMessage(item.messages) }}
          </div>

          <div class="RecordTime">
            {{ formatDateTime(item.updated_at) }}
          </div>
        </div>

        <template #right>
          <div class="DeleteBtn" @click="handleDelete(item.id)">
            <van-icon name="delete-o" size="22"/>
            <span>删除</span>
          </div>
        </template>
      </van-swipe-cell>
    </div>

    <van-empty description="请您先登录" v-if="!userId && !isLoading" class="EmptyState">
      <van-button round class="LoginButton" @click="goLogin()">前往登录</van-button>
    </van-empty>

    <van-empty
        :description="searchQuery ? '未找到相关记录' : '您还没有记录哦~'"
        v-if="userId && !isLoading && filteredLists.length === 0"
        class="EmptyState"
    />
  </div>
</template>

<script>
import {Dialog, Toast} from "vant";
import {supabase} from '@/config/supabase';
import {getUserChatList, deleteChat} from "@/api/chat";

export default {
  name: "EditItemPage",
  data() {
    return {
      userId: "",
      infoLists: [],
      isLoading: true,
      searchQuery: "",
    }
  },

  computed: {
    filteredLists() {
      if (!this.searchQuery) return this.infoLists;
      return this.infoLists.filter(item =>
          item.title?.includes(this.searchQuery) ||
          JSON.stringify(item.messages).includes(this.searchQuery)
      );
    },
  },

  async mounted() {
    await this.checkUser();
  },

  methods: {
    // 检查登录状态并获取数据
    async checkUser() {
      const {data: {session}} = await supabase.auth.getSession();
      if (session) {
        this.userId = session.user.id;
        await this.getHistory();
      } else {
        this.userId = "";
        this.isLoading = false;
      }
    },

    // 前往登录
    goLogin() {
      this.$router.push("/login");
    },

    async getHistory() {
      try {
        const data = await getUserChatList(this.userId);
        this.infoLists = data || [];
      } catch (error) {
        console.error(error);
        Toast.fail("获取历史记录失败");
      } finally {
        this.isLoading = false;
      }
    },

    // 删除对话记录
    handleDelete(id) {
      Dialog.confirm({
        title: '删除确认',
        message: '确定要删除这条对话记录吗？删除后不可恢复。',
        confirmButtonColor: '#ee0a24',
        confirmButtonText: '删除',
        cancelButtonText: '取消',
      }).then(async () => {
        try {
          await deleteChat(id);
          this.infoLists = this.infoLists.filter(item => item.id !== id);
          Toast.success('删除成功');
        } catch (e) {
          Toast.fail('删除失败');
        }
      }).catch(() => {});
    },

    // 处理点击事件
    handleClick(item) {
      this.$router.push({
        path: "/chat",
        query: {
          chat_id: item.id,
          style: item.title
        }
      });
    },

    // 获取最后一条消息作为预览
    getLatestMessage(messages) {
      if (!messages || messages.length === 0) return '暂无内容';
      const lastMsg = messages[messages.length - 1];
      return lastMsg.content || '暂无内容';
    },

    // 格式化日期（月-日）
    formatDate(dateStr) {
      if (!dateStr) return '';
      const date = new Date(dateStr);
      return `${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;
    },

    // 格式化日期时间（年-月-日 时:分）
    formatDateTime(dateStr) {
      if (!dateStr) return '';
      const date = new Date(dateStr);
      const y = date.getFullYear();
      const m = (date.getMonth() + 1).toString().padStart(2, '0');
      const d = date.getDate().toString().padStart(2, '0');
      const hh = date.getHours().toString().padStart(2, '0');
      const mm = date.getMinutes().toString().padStart(2, '0');
      return `${y}-${m}-${d} ${hh}:${mm}`;
    },

  }
}
</script>

<style scoped>
.All {
  width: 100%;
  min-height: 100%;
  padding-bottom: 20px;
}

.Header {
  width: 100%;
  padding: 12px 14px;
  box-sizing: border-box;
  position: sticky;
  top: 50px;
  background-color: rgba(244, 245, 247, 0.96);
  backdrop-filter: blur(10px);
  z-index: 10;
  border-bottom: 1px solid #eaecf0;
}

.SearchBox {
  width: 100%;
  height: 40px;
  background-color: #fff;
  border-radius: 20px;
  display: flex;
  align-items: center;
  padding: 0 14px;
  box-sizing: border-box;
  border: 1px solid #e0e3e9;
  box-shadow: 0 1px 4px rgba(0,0,0,0.05);
}

.SearchIcon {
  font-size: 16px;
  color: #aaa;
  margin-right: 8px;
}

.SearchInput {
  flex: 1;
  height: 100%;
  border: none;
  background: transparent;
  outline: none;
  font-size: 14px;
  color: #333;
}

.SearchInput::placeholder {
  color: #bbb;
}

.SkeletonBox {
  padding: 20px 16px;
}

.RecordList {
  width: 100%;
  padding: 12px 14px;
  box-sizing: border-box;
}

.SwipeCell {
  margin-bottom: 10px;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.07);
}

.RecordCard {
  width: 100%;
  background: #fff;
  border-radius: 14px;
  padding: 15px 16px 13px 20px;
  box-sizing: border-box;
  border-left: 4px solid #36c48a;
  -webkit-tap-highlight-color: transparent;
  user-select: none;
  transition: background 0.15s;
  cursor: pointer;
}

.SwipeCell .RecordCard {
  margin-bottom: 0;
  border-radius: 0;
}

.RecordCard:active {
  background: #fafafa;
}

.RecordHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.RecordTitle {
  flex: 1;
  font-size: 16px;
  font-weight: 700;
  color: #1a1a2e;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-right: 8px;
}

.RecordAction {
  display: flex;
  align-items: center;
  gap: 3px;
  font-size: 12px;
  color: #36c48a;
  flex-shrink: 0;
  background: #edfaf4;
  padding: 3px 8px;
  border-radius: 12px;
  border: 1px solid #c5edd9;
}

.RecordAction i {
  font-size: 11px;
}

.RecordContent {
  font-size: 13px;
  color: #777;
  line-height: 1.65;
  margin-bottom: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.RecordTime {
  font-size: 11px;
  color: #b0b5be;
}

.EmptyState {
  padding: 60px 20px;
}

.LoginButton {
  width: 140px;
  height: 44px;
  background-color: #333;
  border: none;
  color: #fff;
  font-size: 15px;
}

.All::-webkit-scrollbar {
  width: 0;
  display: none;
}

.DeleteBtn {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
  height: 100%;
  min-width: 76px;
  padding: 0 18px;
  background: linear-gradient(160deg, #ff6b6b, #d9363e);
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  user-select: none;
}
</style>